import React, { useId } from 'react'
import ReactTooltip from 'react-tooltip'

const DefaultPriceTooltip = () => {
  const id = useId()
  return (
    <div className="dome-d-flex dome-align-center dome-gap6">
      <span className="dome-p1 dome-color-dark-grey">default price</span>
      <span>
        <i className="fa-light fa-circle-question dome-color-sage" data-tip data-for={id}></i>
        <ReactTooltip
          id={id}
          type="light"
          place="bottom"
          effect="solid"
          padding="6px 12px"
          arrowColor="transparent"
          backgroundColor="#F9F9F9"
          offset={{ top: 13, left: '-100%' }}
        >
          <div className="dome-d-flex dome-flex-column">
            <span className="dome-p2 dome-color-darkest-grey">why can’t I change this price?</span>
            <span className="dome-p3 dome-color-darkest-grey dome-text-w300">Lorem ipsum</span>
          </div>
        </ReactTooltip>
      </span>
    </div>
  )
}
export default DefaultPriceTooltip
